export const services = [
  {
    id: 1,
    title: "Roof Cleaning",
    description: "Professional roof cleaning to remove moss, algae, and debris. Extends roof life and improves curb appeal.",
    icon: "home",
    residential: true,
    commercial: true
  },
  {
    id: 2,
    title: "Gutter Cleaning",
    description: "Thorough gutter cleaning and debris removal. Prevents water damage and ensures proper drainage.",
    icon: "droplets",
    residential: true,
    commercial: true
  },
  {
    id: 3,
    title: "Pressure Washing",
    description: "High-pressure cleaning for driveways, walkways, and hard surfaces. Removes stubborn stains and grime.",
    icon: "spray-can",
    residential: true,
    commercial: true
  },
  {
    id: 4,
    title: "Soft Washing",
    description: "Gentle, low-pressure cleaning for delicate surfaces. Safe for siding, painted surfaces, and more.",
    icon: "sparkles",
    residential: true,
    commercial: true
  },
  {
    id: 5,
    title: "House Washing",
    description: "Complete exterior house washing. Restores your home's beauty and protects your investment.",
    icon: "building",
    residential: true,
    commercial: false
  },
  {
    id: 6,
    title: "Window & Glass Cleaning",
    description: "Streak-free window and glass cleaning. Crystal clear results for residential and commercial properties.",
    icon: "square",
    residential: true,
    commercial: true
  },
  {
    id: 7,
    title: "Fence Cleaning",
    description: "Restore your fence to like-new condition. Remove dirt, mildew, and weathering.",
    icon: "fence",
    residential: true,
    commercial: true
  },
  {
    id: 8,
    title: "Driveway Cleaning",
    description: "Deep cleaning for driveways and parking areas. Remove oil stains, tire marks, and buildup.",
    icon: "car",
    residential: true,
    commercial: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "West Vancouver",
    rating: 5,
    text: "Outstanding service! My roof looks brand new after 15 years. The team was professional, punctual, and thorough. Highly recommend!",
    service: "Roof Cleaning"
  },
  {
    id: 2,
    name: "David Chen",
    location: "Downtown Vancouver",
    rating: 5,
    text: "We use Vancouver House Wash for our commercial property quarterly. Always reliable, efficient, and great pricing. Our building always looks pristine.",
    service: "Commercial Cleaning"
  },
  {
    id: 3,
    name: "Jennifer Roberts",
    location: "North Vancouver",
    rating: 5,
    text: "The before and after difference on our driveway was incredible! Years of stains completely gone. Worth every penny.",
    service: "Driveway Cleaning"
  },
  {
    id: 4,
    name: "Michael Thompson",
    location: "Burnaby",
    rating: 5,
    text: "Professional team that truly cares about quality. They took extra time to ensure every window was spotless. Will be using them again!",
    service: "Window Cleaning"
  }
];

export const galleryImages = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
    after: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800",
    title: "Roof Moss Removal",
    description: "Complete transformation of moss-covered roof"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800",
    after: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800",
    title: "House Exterior Wash",
    description: "Restored siding to original brightness"
  },
  {
    id: 3,
    before: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800",
    after: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800",
    title: "Driveway Pressure Wash",
    description: "Years of stains removed"
  },
  {
    id: 4,
    before: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800",
    after: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800",
    title: "Window Cleaning",
    description: "Crystal clear results"
  }
];

export const serviceAreas = [
  "Vancouver",
  "West Vancouver",
  "North Vancouver",
  "Burnaby",
  "Richmond",
  "New Westminster",
  "Coquitlam",
  "Port Moody",
  "Surrey",
  "Delta"
];

export const timeSlots = [
  "8:00 AM - 10:00 AM",
  "10:00 AM - 12:00 PM",
  "12:00 PM - 2:00 PM",
  "2:00 PM - 4:00 PM",
  "4:00 PM - 6:00 PM"
];

export const recentWorkImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800",
    title: "Residential Roof Cleaning",
    description: "Complete roof restoration in North Vancouver"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800",
    title: "Driveway Pressure Wash",
    description: "Deep cleaning service in Burnaby"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800",
    title: "Window Cleaning",
    description: "Commercial building window service"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800",
    title: "House Exterior Wash",
    description: "Full exterior cleaning in West Vancouver"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
    title: "Gutter Maintenance",
    description: "Gutter cleaning and repair service"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800",
    title: "Fence Restoration",
    description: "Wooden fence cleaning and treatment"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1625486986745-1617998711c1?w=800",
    title: "Deck Cleaning",
    description: "Patio and deck pressure washing"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800",
    title: "Commercial Property",
    description: "Large-scale commercial cleaning project"
  }
];
